export default __webpack_public_path__ + "static/media/firebase_logo.0c1f57e7.webp";